module.exports = __webpack_public_path__ + "img/9.047f59ae.jpg";